import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// Client-side route changes keep the previous scroll position (no full page
// load happens), so pages could open mid-scroll. This resets to the top on
// every path change, mimicking a normal page load.
const ScrollRestoration = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

export default ScrollRestoration
